/**
 * Constantes dos recursos de permissão para uso nos templates.
 * A source of truth é o enum EnumRecursoPermissao no backend.
 * A tela de gerenciamento (tab-permissoes) carrega os recursos via API.
 */
export enum RecursoPermissao {
  // Recursos independentes do Cliente (tabs com controller próprio)
  CLIENTE_SOCIO_READ = 'CLIENTE_SOCIO_READ',
  CLIENTE_SOCIO_CREATE = 'CLIENTE_SOCIO_CREATE',
  CLIENTE_SOCIO_UPDATE = 'CLIENTE_SOCIO_UPDATE',
  CLIENTE_SOCIO_DELETE = 'CLIENTE_SOCIO_DELETE',

  SOCIO_READ = 'SOCIO_READ',
  SOCIO_CREATE = 'SOCIO_CREATE',
  SOCIO_UPDATE = 'SOCIO_UPDATE',

  CLIENTE_SENHA_READ = 'CLIENTE_SENHA_READ',
  CLIENTE_SENHA_CREATE = 'CLIENTE_SENHA_CREATE',
  CLIENTE_SENHA_UPDATE = 'CLIENTE_SENHA_UPDATE',
  CLIENTE_SENHA_DELETE = 'CLIENTE_SENHA_DELETE',

  CLIENTE_PARTICULARIDADE_READ = 'CLIENTE_PARTICULARIDADE_READ',
  CLIENTE_PARTICULARIDADE_CREATE = 'CLIENTE_PARTICULARIDADE_CREATE',
  CLIENTE_PARTICULARIDADE_UPDATE = 'CLIENTE_PARTICULARIDADE_UPDATE',
  CLIENTE_PARTICULARIDADE_DELETE = 'CLIENTE_PARTICULARIDADE_DELETE',

  CLIENTE_CONFIG_CONTABIL_READ = 'CLIENTE_CONFIG_CONTABIL_READ',
  CLIENTE_CONFIG_CONTABIL_CREATE = 'CLIENTE_CONFIG_CONTABIL_CREATE',
  CLIENTE_CONFIG_CONTABIL_UPDATE = 'CLIENTE_CONFIG_CONTABIL_UPDATE',
  CLIENTE_CONFIG_CONTABIL_DELETE = 'CLIENTE_CONFIG_CONTABIL_DELETE',

  CLIENTE_SINDICATO_READ = 'CLIENTE_SINDICATO_READ',
  CLIENTE_SINDICATO_CREATE = 'CLIENTE_SINDICATO_CREATE',
  CLIENTE_SINDICATO_UPDATE = 'CLIENTE_SINDICATO_UPDATE',
  CLIENTE_SINDICATO_DELETE = 'CLIENTE_SINDICATO_DELETE',

  SINDICATO_RESOLUCAO_READ = 'SINDICATO_RESOLUCAO_READ',
  SINDICATO_RESOLUCAO_CREATE = 'SINDICATO_RESOLUCAO_CREATE',
  SINDICATO_RESOLUCAO_UPDATE = 'SINDICATO_RESOLUCAO_UPDATE',
  SINDICATO_RESOLUCAO_DELETE = 'SINDICATO_RESOLUCAO_DELETE',

  SINDICATO_RESOLUCAO_TAXA_ASSISTENCIAL_READ = 'SINDICATO_RESOLUCAO_TAXA_ASSISTENCIAL_READ',
  SINDICATO_RESOLUCAO_TAXA_ASSISTENCIAL_CREATE = 'SINDICATO_RESOLUCAO_TAXA_ASSISTENCIAL_CREATE',
  SINDICATO_RESOLUCAO_TAXA_ASSISTENCIAL_UPDATE = 'SINDICATO_RESOLUCAO_TAXA_ASSISTENCIAL_UPDATE',
  SINDICATO_RESOLUCAO_TAXA_ASSISTENCIAL_DELETE = 'SINDICATO_RESOLUCAO_TAXA_ASSISTENCIAL_DELETE',

  SINDICATO_RESOLUCAO_MENSALIDADE_SINDICAL_READ = 'SINDICATO_RESOLUCAO_MENSALIDADE_SINDICAL_READ',
  SINDICATO_RESOLUCAO_MENSALIDADE_SINDICAL_CREATE = 'SINDICATO_RESOLUCAO_MENSALIDADE_SINDICAL_CREATE',
  SINDICATO_RESOLUCAO_MENSALIDADE_SINDICAL_UPDATE = 'SINDICATO_RESOLUCAO_MENSALIDADE_SINDICAL_UPDATE',
  SINDICATO_RESOLUCAO_MENSALIDADE_SINDICAL_DELETE = 'SINDICATO_RESOLUCAO_MENSALIDADE_SINDICAL_DELETE',

  SINDICATO_RESOLUCAO_CONTRIBUICAO_NEGOCIAL_READ = 'SINDICATO_RESOLUCAO_CONTRIBUICAO_NEGOCIAL_READ',
  SINDICATO_RESOLUCAO_CONTRIBUICAO_NEGOCIAL_CREATE = 'SINDICATO_RESOLUCAO_CONTRIBUICAO_NEGOCIAL_CREATE',
  SINDICATO_RESOLUCAO_CONTRIBUICAO_NEGOCIAL_UPDATE = 'SINDICATO_RESOLUCAO_CONTRIBUICAO_NEGOCIAL_UPDATE',
  SINDICATO_RESOLUCAO_CONTRIBUICAO_NEGOCIAL_DELETE = 'SINDICATO_RESOLUCAO_CONTRIBUICAO_NEGOCIAL_DELETE',

  // Ações de negócio - Tarefas
  LOTE_GERACAO_TAREFA_READ = 'LOTE_GERACAO_TAREFA_READ',
  LOTE_GERACAO_TAREFA_CONFIRMAR = 'LOTE_GERACAO_TAREFA_CONFIRMAR',
  TAREFA_GERAR = 'TAREFA_GERAR',
  TAREFA_CRIAR_SEM_TEMPLATE = 'TAREFA_CRIAR_SEM_TEMPLATE',
  TAREFA_VISUALIZAR_TODAS = 'TAREFA_VISUALIZAR_TODAS',
  TAREFA_VISUALIZAR_TODAS_SETOR = 'TAREFA_VISUALIZAR_TODAS_SETOR',
  TAREFA_SINCRONIZAR_ZEN = 'TAREFA_SINCRONIZAR_ZEN',
  TAREFA_ANEXO_VER = 'TAREFA_ANEXO_VER',
  TAREFA_ANEXO_EDITAR = 'TAREFA_ANEXO_EDITAR',
  PROJETO_CREATE = 'PROJETO_CREATE',
  PROJETO_VISUALIZAR_TODOS = 'PROJETO_VISUALIZAR_TODOS',

  // Ações de negócio - Captação
  CAPTACAO_ANEXO_VER = 'CAPTACAO_ANEXO_VER',
  CAPTACAO_ANEXO_EDITAR = 'CAPTACAO_ANEXO_EDITAR',

  // Ações de negócio - Não Conformidade
  NAO_CONFORMIDADE_APROVAR = 'NAO_CONFORMIDADE_APROVAR',
  NAO_CONFORMIDADE_VISUALIZAR = 'NAO_CONFORMIDADE_VISUALIZAR',

  // Ações de negócio - REINF
  REINF_GERAR_FECHAMENTO = 'REINF_GERAR_FECHAMENTO',
  REINF_APROVAR_FECHAMENTO_FISCAL = 'REINF_APROVAR_FECHAMENTO_FISCAL',

  // Carteira de Clientes (CRUD padrão — usados para controle de UI)
  CARTEIRA_CLIENTES_CREATE = 'CARTEIRA_CLIENTES_CREATE',
  CARTEIRA_CLIENTES_UPDATE = 'CARTEIRA_CLIENTES_UPDATE',

  // Serviços Prestados
  SERVICO_PRESTADO_READ = 'SERVICO_PRESTADO_READ',
  SERVICO_PRESTADO_CREATE = 'SERVICO_PRESTADO_CREATE',
  SERVICO_PRESTADO_UPDATE = 'SERVICO_PRESTADO_UPDATE',
  SERVICO_PRESTADO_DELETE = 'SERVICO_PRESTADO_DELETE',

  // Serviços Prestados do Cliente
  CLIENTE_SERVICO_PRESTADO_READ = 'CLIENTE_SERVICO_PRESTADO_READ',
  CLIENTE_SERVICO_PRESTADO_CREATE = 'CLIENTE_SERVICO_PRESTADO_CREATE',
  CLIENTE_SERVICO_PRESTADO_UPDATE = 'CLIENTE_SERVICO_PRESTADO_UPDATE',
  CLIENTE_SERVICO_PRESTADO_DELETE = 'CLIENTE_SERVICO_PRESTADO_DELETE',

  // Visualização
  VISUALIZACAO_UNIFICADA = 'VISUALIZACAO_UNIFICADA',

  // Ações de negócio - Cliente
  CLIENTE_EDITAR_CONFIGURACAO = 'CLIENTE_EDITAR_CONFIGURACAO',
  CLIENTE_EDITAR_SEM_MOVIMENTO = 'CLIENTE_EDITAR_SEM_MOVIMENTO',
  CLIENTE_CONSULTAR_TODAS_CARTEIRAS = 'CLIENTE_CONSULTAR_TODAS_CARTEIRAS',
  CLIENTE_NOTIFICACAO_SEM_MOVIMENTO = 'CLIENTE_NOTIFICACAO_SEM_MOVIMENTO',

  // Relatórios
  RELATORIO_READ = 'RELATORIO_READ',
  RELATORIO_CLIENTE_GERAR = 'RELATORIO_CLIENTE_GERAR',
  RELATORIO_CARTEIRA_GERAR = 'RELATORIO_CARTEIRA_GERAR',

  // Relatórios de Tarefas
  RELATORIO_TAREFA_READ = 'RELATORIO_TAREFA_READ',
  RELATORIO_TAREFA_MATRIZ_GERAR = 'RELATORIO_TAREFA_MATRIZ_GERAR',

  // IRPF
  IRPF_CLIENTE_IRPF_READ = 'IRPF_CLIENTE_IRPF_READ',
  IRPF_CLIENTE_IRPF_CREATE = 'IRPF_CLIENTE_IRPF_CREATE',
  IRPF_CLIENTE_IRPF_UPDATE = 'IRPF_CLIENTE_IRPF_UPDATE',
  IRPF_CLIENTE_IRPF_DELETE = 'IRPF_CLIENTE_IRPF_DELETE',
  IRPF_GRUPO_IRPF_READ = 'IRPF_GRUPO_IRPF_READ',
  IRPF_GRUPO_IRPF_CREATE = 'IRPF_GRUPO_IRPF_CREATE',
  IRPF_GRUPO_IRPF_UPDATE = 'IRPF_GRUPO_IRPF_UPDATE',
  IRPF_GRUPO_IRPF_DELETE = 'IRPF_GRUPO_IRPF_DELETE',
  IRPF_ROTINA_IRPF_READ = 'IRPF_ROTINA_IRPF_READ',
  IRPF_ROTINA_IRPF_CREATE = 'IRPF_ROTINA_IRPF_CREATE',
  IRPF_ROTINA_IRPF_UPDATE = 'IRPF_ROTINA_IRPF_UPDATE',
  IRPF_ROTINA_IRPF_DELETE = 'IRPF_ROTINA_IRPF_DELETE',
  IRPF_ABERTURA_READ = 'IRPF_ABERTURA_READ',
  IRPF_ABERTURA_CREATE = 'IRPF_ABERTURA_CREATE',
  IRPF_ABERTURA_UPDATE = 'IRPF_ABERTURA_UPDATE',
  IRPF_ABERTURA_DELETE = 'IRPF_ABERTURA_DELETE',
  IRPF_FICHA_READ = 'IRPF_FICHA_READ',
  IRPF_FICHA_CREATE = 'IRPF_FICHA_CREATE',
  IRPF_FICHA_UPDATE = 'IRPF_FICHA_UPDATE',
  IRPF_FICHA_DELETE = 'IRPF_FICHA_DELETE',
  IRPF_PODE_EDITAR_OUTROS_RESPONSAVEIS = 'IRPF_PODE_EDITAR_OUTROS_RESPONSAVEIS',
  IRPF_FICHA_TAB_FECHAMENTO_VER = 'IRPF_FICHA_TAB_FECHAMENTO_VER',
  IRPF_FICHA_TAB_FECHAMENTO_EDITAR = 'IRPF_FICHA_TAB_FECHAMENTO_EDITAR',
  IRPF_PODE_VER_SENHA_TODOS_CLIENTES = 'IRPF_PODE_VER_SENHA_TODOS_CLIENTES',
  DOCUMENTACAO_SISTEMA_GERENCIAR_PASTA = 'DOCUMENTACAO_SISTEMA_GERENCIAR_PASTA',
  DOCUMENTACAO_SISTEMA_MODERAR = 'DOCUMENTACAO_SISTEMA_MODERAR',

  // Integração
  INTEGRACAO_TAB_ENTREVISTA_VER = 'INTEGRACAO_TAB_ENTREVISTA_VER',
  INTEGRACAO_TAB_ENTREVISTA_EDITAR = 'INTEGRACAO_TAB_ENTREVISTA_EDITAR',

  INTEGRACAO_TEMPLATE_QUESTIONARIO_READ = 'INTEGRACAO_TEMPLATE_QUESTIONARIO_READ',
  INTEGRACAO_TEMPLATE_QUESTIONARIO_CREATE = 'INTEGRACAO_TEMPLATE_QUESTIONARIO_CREATE',
  INTEGRACAO_TEMPLATE_QUESTIONARIO_UPDATE = 'INTEGRACAO_TEMPLATE_QUESTIONARIO_UPDATE',
  INTEGRACAO_TEMPLATE_QUESTIONARIO_DELETE = 'INTEGRACAO_TEMPLATE_QUESTIONARIO_DELETE',

  INTEGRACAO_TAB_CHECKLIST_VER = 'INTEGRACAO_TAB_CHECKLIST_VER',
  INTEGRACAO_TAB_CHECKLIST_EDITAR = 'INTEGRACAO_TAB_CHECKLIST_EDITAR',

  INTEGRACAO_TEMPLATE_CHECKLIST_READ = 'INTEGRACAO_TEMPLATE_CHECKLIST_READ',
  INTEGRACAO_TEMPLATE_CHECKLIST_CREATE = 'INTEGRACAO_TEMPLATE_CHECKLIST_CREATE',
  INTEGRACAO_TEMPLATE_CHECKLIST_UPDATE = 'INTEGRACAO_TEMPLATE_CHECKLIST_UPDATE',
  INTEGRACAO_TEMPLATE_CHECKLIST_DELETE = 'INTEGRACAO_TEMPLATE_CHECKLIST_DELETE',

  INTEGRA_CONTADOR_ADMIN = 'INTEGRA_CONTADOR_ADMIN',

  AGENDA_SALA_READ = 'AGENDA_SALA_READ',
  AGENDA_SALA_RESERVAR = 'AGENDA_SALA_RESERVAR',
  AGENDA_SALA_GERENCIAR = 'AGENDA_SALA_GERENCIAR',

  REGULARIDADE_CONFIG_CLIENTE_EDITAR = 'REGULARIDADE_CONFIG_CLIENTE_EDITAR',
}
